import React from "react";
import Footer from "../components/Footer";
import HeaderInside from "../components/HeaderInside";

const Thanks = () => {
  return (
    <div className="App">
      <HeaderInside />
      <div className="aboutUsContainer">
        <div className="aboutUsTitle">
          Thank you
          <hr />
        </div>
        <div className="contactSectionText">We will get back to you</div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <Footer />
    </div>
  );
};

export default Thanks;
